import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import MocktestsPage from './pages/MocktestsPage';
import CheckoutPage from './pages/CheckoutPage';
import SuccessPage from './pages/SuccessPage';
import { CartProvider } from './context/CartContext';
import './index.css';
import SingleCheckoutPage from './pages/SingleCheckoutPage';
import SamaiLandingPage from './pages/SamaiLandingPage';

function App() {
  return (
      <CartProvider>
        <Router>
          <div className="flex flex-col min-h-screen bg-gray-50">
            <Navbar />
            <main className="flex-grow">
              <Routes>
              <Route path="/" element={<SingleCheckoutPage />} />

                <Route path="/checkout" element={<SingleCheckoutPage />} />
                {/* <Route path="/mocktests" element={<MocktestsPage />} />
                <Route path="/checkout" element={<CheckoutPage />} /> */}
                <Route path="/success" element={<SuccessPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </CartProvider>
  );
}

export default App;